import { render, staticRenderFns } from "./general-insurance-list.vue?vue&type=template&id=df6e140c"
import script from "./general-insurance-list.vue?vue&type=script&lang=ts"
export * from "./general-insurance-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports